@if (room() && members) {
  <div class="mb-1">
    <div class="mb-1 flex items-center justify-between cursor-pointer">
      <div class="flex items-center" (click)="selectRoom(room()?.id)">
        <div class="relative">
          @if (profile_mini_parameters) {
            <offconon-profile-mini
              data-testid="post-header__profile"
              [parameters]="profile_mini_parameters">
              <span sub_line>
                <div class="m-0 text-xs text-primary">{{ second_line }}</div>
                @if (last_msg && unread_count > 1) {
                  <div class="m-0 text-xs {{ unread_count > 1 ? 'font-bold' : '' }} ">
                    {{ last_msg | translate | truncate: truncate_unread }}
                  </div>
                }
              </span>
            </offconon-profile-mini>
          }
        </div>
      </div>

      <div class="flex flex-row">
        @if (parameters?.view_type !== 'widget') {
          <div class="text-primary cursor-pointer" (click)="startCall()">
            <mat-icon>call</mat-icon>
          </div>
        }

        <div class="flex items-center gap-2">
          @if (last_msg && unread_count > 1) {
            @if (unread_count > 1) {
              <span class="!text-primary !text-xs ml-1"
                ><i class="pi pi-circle-on !text-xs"></i
              ></span>
            }
          }
          <div>
            <span class="cursor-pointer opacity-50 hover:opacity-100 hover:text-primary text-xs">
              <mat-icon (click)="menu.toggle($event)">more_vert</mat-icon>
            </span>

            <p-menu #menu [appendTo]="'body'" [popup]="true" [model]="items">
              <ng-template #submenuheader let-item>
                @if (item?.visible !== false) {
                  <div class="font-bold">
                    {{ item.label }}
                  </div>
                }
              </ng-template>
              <ng-template #item let-item>
                @if (item?.visible !== false) {
                  <a class="flex items-center p-2 cursor-pointer gap-2">
                    <span
                      class="inline-flex items-center justify-center {{
                        item?.icon_color ? item?.icon_color : 'text-blue-500'
                      }}">
                      <mat-icon fontIcon="{{ item.icon ? item.icon : 'add_circle' }}" />
                    </span>
                    <span class="inline-flex flex-col gap-2">
                      <span class="font-light text-sm">{{ item.label }}</span>
                    </span>
                  </a>
                }
              </ng-template>
            </p-menu>
          </div>
        </div>
      </div>
    </div>
  </div>
}

@defer (when dialogVisible) {
  <p-confirmDialog
    key="chatroomDeleteDialog"
    [breakpoints]="{ '960px': '75vw' }"
    [baseZIndex]="2"
    [appendTo]="'body'">
    <ng-template #headless let-message let-onAccept="onAccept" let-onReject="onReject">
      <div class="flex flex-col items-center p-8 bg-surface-0 dark:bg-surface-900 rounded">
        <span class="font-bold text-2xl block mb-2 mt-6">{{ message?.header }}</span>
        <p class="mb-0">{{ message?.message }}</p>
        <div class="flex items-center gap-2 mt-6">
          <p-button label="{{ 'Yes, I want to delete it.' | translate }}" (onClick)="onAccept()" />
          <p-button label="{{ 'Cancel' | translate }}" [outlined]="true" (onClick)="onReject()" />
        </div>
      </div>
    </ng-template>
  </p-confirmDialog>

  <p-confirmDialog
    key="chatroomLeaveDialog"
    [breakpoints]="{ '960px': '75vw' }"
    [baseZIndex]="2"
    [appendTo]="'body'">
    <ng-template #headless let-message let-onAccept="onAccept" let-onReject="onReject">
      <div class="flex flex-col items-center p-8 bg-surface-0 dark:bg-surface-900 rounded">
        <span class="font-bold text-2xl block mb-2 mt-6">{{ message?.header }}</span>
        <p class="mb-0">{{ message?.message }}</p>
        <div class="flex items-center gap-2 mt-6">
          <p-button label="{{ 'Yes' | translate }}" (onClick)="onAccept()" />
          <p-button label="{{ 'Cancel' | translate }}" [outlined]="true" (onClick)="onReject()" />
        </div>
      </div>
    </ng-template>
  </p-confirmDialog>
}
